import React from 'react';
import styled from 'styled-components';
import { theme } from './theme';
import GlobalStyle from './GlobalStyle';
import Nav from './components/Nav.jsx';
import Hero from './components/Hero.jsx';
import Ticker from './components/Ticker.jsx';
import AboutMe from './components/AboutMe.jsx';
import Gallery1 from './components/Gallery.jsx';
import ThreeDWork from './components/ThreeDWork.jsx';
import TimeLine from './components/TimeLine.jsx';
import Contact from './components/contact.jsx';
import Footer from './components/footer.jsx';

const noiseTexture = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='140' height='140'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`;

const Page = styled.div`
  background: ${theme.bg} ${noiseTexture};
  position: relative;
  overflow: hidden;
`;

function App() {
  return (
    <Page>
      <GlobalStyle />
      <Nav />
      <Hero />
      <Ticker />
      <AboutMe />
      <Gallery1 />
      <ThreeDWork />
      <TimeLine />
      <Contact />
      <Footer />
    </Page>
  );
}

export default App;
